<!--
 * @Description: Jeson Create File
 * @Version: 1.0
 * @Autor: Jeson
 * @Date: 2022-01-08 15:56:53
 * @LastEditors: Jeson
 * @LastEditTime: 2022-01-24 15:23:21
-->
<template>
  <div class="bgf5">
    <iHeader />
    <iNav />
    <iClassify ref="iClassify" :active="activeIndex" all-active />
    <iRightFixedBox />
    <div style="min-height: 600px;">
      <div id="FactoryList">

        <div class="factory-div">

          <div class="factory-div-title">
            <div>
              <img :src="Logo">
              <div>{{ BrandName }}</div>
            </div>
          </div>
          <div class="factory-div-content">
            <div v-for="(item,index) in goods" :key="index" class="factory-div-content-good">
              <NewProductItem :product="item" />
            </div>
            <EmptyControl v-if="!goods.length" style="margin: 20px 0; padding: 100px 0; width: 1200px;" type="goods" text="没有找到商品哦~" />
          </div>

        </div>
      </div>
    </div>
    <iFooter />
    <add-new-goods-collect-tips ref="addNewCollectTipsRef" />
  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iNav from '@/components/Nav'
import iClassify from '@/components/Classify'
import iFooter from '@/components/Footer'
import { BaseMixin } from '@/mixins/BaseMixin'

import AddNewGoodsCollectTips from '@/components/AddNewGoodsCollectTips.vue'
import iRightFixedBox from '@/components/RightFixedBox'

export default {
  name: 'BrandMoreList',
  components: {
    iHeader,
    iNav,
    iClassify,
    iFooter,
    AddNewGoodsCollectTips,

    iRightFixedBox
  },
  mixins: [BaseMixin],
  data() {
    return {
      activeIndex: 1,
      goods: [],
      Id: '',
      Offset: 0,
      IsHasNext: false,
      loading: false,
      Logo: '',
      BrandName: '',
      timer: null
    }
  },
  watch: {},
  destroyed() {

  },
  created() {
    this.Id = this.$route.query.Id
    this.BrandName = this.$route.query.BrandName
    if (!this.BrandName) {
      this.getInfo()
    }
    this.Logo = this.$route.query.Logo
    this.getBrandGoodList()
  },
  beforeDestroy() {

  },
  mounted() {
    // 绑定监听页面滑动方法
    window.addEventListener('scroll', this.handleSearch)
  },
  methods: {
    async getInfo() {
      const res = await this.getAction('/clientapi_brand/Brand/Detail', { Id: this.Id })
      if (res.IsSuccess) {
        this.Logo = res.Data.Logo
        this.BrandName = res.Data.Name
      }
    },
    async getBrandGoodList() {
      this.loading = true
      const res = await this.getAction('/api_goods/GoodsSku/ListForCustomerV3', { BrandIds: this.Id, Offset: this.Offset })
      if (res.IsSuccess) {
        res.Data.GoodsList.map(oo => {
          this.goods.push(oo)
        })
        this.IsHasNext = res.Data.IsHasNext
        this.Offset = res.Data.Offset
        this.loading = false
      }
      this.$hys.clearLoading()
    },
    /*
     * 监听页面滑动
     */
    handleSearch() {
      // 获取当前页面高度
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

      // 获取网页可见区域高
      const clientHeight = document.body.clientHeight
      // 获取网页正文全文高
      const scrollHeight = document.body.scrollHeight

      // 当前页面高度大于指定位置时记录

      // 到达页面底部时
      if (scrollTop + clientHeight === scrollHeight && this.IsHasNext) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        // 开启加载层
        this.$hys.openLoading()
        // 延时请求
        this.timer = setTimeout(() => {
          // 获取list
          this.getBrandGoodList()
        }, 1000)
      }
    }
  }
}
</script>

<style lang="less" scoped>
#FactoryList {
  margin: auto;
  width: 1200px;
  max-width: 1200px;

  .factory-div {
    margin-top: 17px;
    border-radius: 2px;
    height: 529px;
    height: 100%;
    background: #FFFFFF;

    .factory-div-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 80px;
      background: #FDD6D2;

      :nth-child(1) {
        display: flex;
        align-items: center;

        div {
          font-size: 24px;
          font-weight: 600;
          color: #111A34;
        }
      }

      :nth-child(2) {
        margin-right: 22px;
        font-size: 18px;
        font-weight: 500;
        color: #666F83;
      }

      img {
        margin-right: 15px;
        margin-left: 22px;
        border-radius: 10px;
        width: 80px;
        height: 60px;
      }
    }

    .factory-div-content {
      display: flex;
      flex-wrap: wrap;

      .factory-div-content-good {
        padding: 8px 0;
        width: 240px;
      }
    }
  }
}
</style>
